import React from "react";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import { calculateCost } from "LIB/formatters/currency";
import EmailLink from "MODULES/shared/components/EmailLink/EmailLink";
import { PartNumber, ClipboardCopy } from "MODULES/shared/components";

export default function Total({ part, quantity, cost, email }) {
  return (
    <div className="well">
      <h6 className="h4">Summary</h6>
      <table className="table table-condensed table-padding-horizonal-none margin-bottom-none">
        <tbody>
          {!isEmpty(email) && (
            <tr>
              <td>
                Email: <EmailLink email={email} />
              </td>
              <td />
            </tr>
          )}
          <tr>
            <td>
              <div style={{ whiteSpace: "nowrap" }}>
                <PartNumber part={part} />
                <ClipboardCopy
                  name={part && part.part_number}
                  type="PN"
                  handleClick={() =>
                    navigator.clipboard.writeText(part.part_number)}
                />
              </div>
              <br />
              <em className="text-muted">{part && part.description}</em>
            </td>
            <td className="text-right" />
          </tr>
        </tbody>
      </table>
      <hr className="hr-xs" />
      <table className="table table-condensed table-padding-horizonal-none">
        <tbody>
          <tr>
            <td>
              <h5 className="h4 margin-top-none margin-bottom-none">Total</h5>
            </td>
            <td className="text-right">
              <h5 className="h4 margin-top-none margin-bottom-none">
                {calculateCost(quantity, cost)}
              </h5>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

Total.propTypes = {
  email: PropTypes.string,
  part: PropTypes.shape({
    part_number: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  }),
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  cost: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Total.jsx